import { render, staticRenderFns } from "./auth-bindphone.vue?vue&type=template&id=319277df&scoped=true"
import script from "./auth-bindphone.vue?vue&type=script&lang=js"
export * from "./auth-bindphone.vue?vue&type=script&lang=js"
import style0 from "./auth-bindphone.vue?vue&type=style&index=0&id=319277df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319277df",
  null
  
)

export default component.exports